import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "../../../../components";
import {
  getIntegrationProperties,
  mappingIntegrationProperties,
} from "../../../../services/api/integrations.api";
import { FormattedMessage, injectIntl } from "react-intl";
import ListDrop from "./MappingProperties/ListDrop";
import { toast, ToastContainer } from "react-toastify";

function MappingModal(props) {
  const [integrationProperties, setIntegrationProperties] = useState(null);
  const [kasprProperties, setKasprProperties] = useState(null);
  const [mappedProperties, setMappedProperties] = useState([]);
  const [mappedValues, setMappedValues] = useState([]);
  const [isCustomValue, setIsCustomValue] = useState([]);
  const [error, setError] = useState("");
  const [propertiesAutoComplete, setPropertiesAutoComplete] = useState(null);
  const [propertyIndex, setPropertyIndex] = useState(-1);
  const [showAutoComplete, setShowAutoComplete] = useState(false);
  const [salesforceTab, setSalesforceTab] = useState("lead");
  const [
    showKasprPropertiesAutoComplete,
    setShowKasprPropertiesAutoComplete,
  ] = useState(false);
  const onChangeKaspr = (e, i) => {
    setError("");
    const regex = new RegExp(e.target.value, "i");
    setPropertiesAutoComplete(
      Object.keys(kasprProperties).filter((property) => {
        if (property.indexOf("customField-") > -1) return false;
        let translation = props.intl.formatMessage({
          id: "leads.properties." + property,
        });
        return !!translation.match(regex);
      })
    );
    mappedProperties[i] = e.target.value;
  };

  const onChangeIntegration = (e, i) => {
    setError("");
    const regex = new RegExp(e.target.value, "i");
    setPropertiesAutoComplete(
      Object.values(kasprProperties).filter((prop) => prop.match(regex))
    );
    mappedValues[i] = e.target.value;
  };

  const handleOnBlur = (e) => {
    for (let i in mappedValues) {
      if (integrationProperties.indexOf(mappedValues[i]) === -1)
        mappedValues[i] = "";
    }
    setShowAutoComplete(false);
  };

  const addMapping = (e, i) => {
    setError("");
    let clone = Object.assign([], mappedProperties);
    clone.push("");
    setMappedProperties(clone);
    clone = Object.assign([], mappedValues);
    clone.push("");
    setMappedValues(clone);
    clone = Object.assign([], isCustomValue);
    clone.push(false);
    setIsCustomValue(clone);
  };

  const handleDeleteMapping = (e, i) => {
    setError("");
    let clone = Object.assign([], mappedProperties);
    clone.splice(i, 1);
    setMappedProperties(clone);
    clone = Object.assign([], mappedValues);
    clone.splice(i, 1);
    setMappedValues(clone);
  };

  const handleCheckbox = async (e, i) => {
    let clone = Object.assign([], isCustomValue);
    if (i < mappedProperties.length) clone[i] = e.target.checked;
    setIsCustomValue(clone);
  };

  const onSelectItem = (type, i) => (value) => {
    setError("");
    switch (type) {
      case "kaspr":
        if (mappedProperties.indexOf(value) >= 0) {
          setShowAutoComplete(false);
          setError(
            props.intl.formatMessage({ id: "leads.properties.propertyUsed" })
          );
          return;
        }
        mappedProperties[i] = value;
        break;
      case "integration":
        if (mappedValues.indexOf(value) >= 0) {
          setShowAutoComplete(false);
          setError(
            props.intl.formatMessage({ id: "leads.properties.propertyUsed" })
          );
          return;
        }
        mappedValues[i] = value;
        break;
    }
  };

  const enableSearch = (e, i) => {
    e.stopPropagation();
    isCustomValue[i] = false;
    setShowAutoComplete(true);
    setShowKasprPropertiesAutoComplete(true);
    setPropertyIndex(i);
  };

  const disableSearch = (i) => () => {
    isCustomValue[i] = true;
  };
  const handleSubmitMapping = async (e) => {
    if (e) e.stopPropagation();
    let mapping = {};
    let abort = false;
    Object.keys(kasprProperties).map((property) => {
      mapping[property] = "";
    });
    mappedProperties.map((property, i) => {
      if (
        !(
          property &&
          property.length &&
          mappedValues[i] &&
          mappedValues[i].length
        )
      ) {
        setError(
          props.intl.formatMessage({ id: "leads.properties.emptyField" })
        );
        return (abort = true);
      }
      if (
        !isCustomValue[i] &&
        Object.keys(kasprProperties).indexOf(property) === -1
      ) {
        setError(
          props.intl.formatMessage({ id: "leads.properties.unknownProperty" }) +
            property
        );
        return (abort = true);
      }
      if (isCustomValue[i]) property = "customField-" + property;
      mapping[property] = mappedValues[i];
    });
    if (abort) {
      setShowAutoComplete(false);
      return;
    }

    let mappingToSave = {};
    let customFields = {};
    for (let m in mapping) {
      if (m.indexOf("customField-") === -1) mappingToSave[m] = mapping[m];
      else customFields[m.replace("customField-", "")] = mapping[m];
    }
    mappingToSave.customFields = customFields;
    let body = {
      mappedProperties: mappingToSave,
      integrationName: props.integration,
    };
    if (props.integration === "salesforce") body.sObject = salesforceTab;
    let { data, statusCode } = await mappingIntegrationProperties(body);

    if (statusCode >= 400)
      return setError(
        data.message === "Permission denied"
          ? props.intl.formatMessage({ id: "permissionDenied" })
          : data && (data.messageTranslated || data.message)
      );

    let keys = [];
    let values = [];
    let customValues = [];
    for (let property in mapping) {
      if (mapping[property] && mapping[property].length) {
        keys.push(property.replace("customField-", ""));
        values.push(mapping[property]);
        customValues.push(property.indexOf("customField-") > -1);
      }
    }
    customValues.push(false);
    setMappedProperties(keys);
    setMappedValues(values);
    setIsCustomValue(customValues);
    props.onHide();
    setError("");
  };

  const handleSalesforceTab = (tab) => {
    setSalesforceTab(tab);
  };

  useEffect(() => {
    if (["linkedin", "zapier", "gmail"].indexOf(props.integration) >= 0) return;
    let body = {
      integrationName: props.integration,
    };
    if (props.integration === "salesforce") body.sObject = salesforceTab;
    props.setIsLoading(true);
    getIntegrationProperties(body).then(({ data, statusCode }) => {
      if (statusCode >= 400) {
        props.setIsLoading(false);
        toast.error(data.messageTranslated || data.message);
        return;
      }
      let properties =
        data && data.properties && data.properties.kasprProperties;
      if (properties && properties.customFields) {
        for (let i in properties.customFields)
          properties["customField-" + i] = properties.customFields[i];
        delete properties.customFields;
        data.properties.kasprProperties = properties;
      }
      setIntegrationProperties(
        data &&
          data.properties &&
          data.properties[props.integration + "Properties"]
      );

      setKasprProperties(
        data && data.properties && data.properties.kasprProperties
      );
      setPropertiesAutoComplete(
        Object.keys(data && data.properties && data.properties.kasprProperties)
      );
      let mapping = data && data.properties && data.properties.kasprProperties;

      let keys = [];
      let values = [];
      let customValues = [];
      for (let property in mapping) {
        if (mapping[property] && mapping[property].length) {
          keys.push(property.replace("customField-", ""));
          values.push(mapping[property]);
          customValues.push(property.indexOf("customField-") > -1);
        }
      }

      setMappedProperties(keys);
      setMappedValues(values);
      setIsCustomValue(customValues);
      props.setIsLoading(false);
    });
  }, [props.integration, salesforceTab]);
  const SalesforceTabs = () => {
    return (
      <div
        className="subscription-tabs"
        style={{
          marginTop: "-10px",
          marginBottom: "40px",
        }}
      >
        <ul className="nav nav-tabs">
          <li onClick={() => handleSalesforceTab("lead")}>
            <a className={salesforceTab === "lead" ? "active" : ""}>
              <FormattedMessage id={"settings.integration.salesforce.lead"} />
            </a>
          </li>
          <li onClick={() => handleSalesforceTab("contact")}>
            <a className={salesforceTab === "contact" ? "active" : ""}>
              <FormattedMessage
                id={"settings.integration.salesforce.contact"}
              />
            </a>
          </li>
        </ul>
      </div>
    );
  };
  if (!(kasprProperties && integrationProperties)) {
    return (
      <div>
        <ToastContainer position="bottom-right" style={{ top: 100 }} />
      </div>
    );
  }
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      className="fade configration-modal-wrapper"
    >
      <div className={"modal-content"} style={{ width: "200%", right: "50%" }}>
        <Modal.Header closeButton className=" border-0">
          <div className="modal-inner-header">
            <h4 className="title">
              <FormattedMessage id={"leads.properties.propertiesConfig"} />
            </h4>
          </div>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="configration-inner-ui">
            {props.integration === "salesforce" && <SalesforceTabs />}
            {!props.isLoading && (
              <table>
                <thead>
                  <tr>
                    <th>
                      <FormattedMessage
                        id={"leads.properties.mappingProperties"}
                        values={{
                          var: "Kaspr",
                        }}
                      />
                    </th>
                    <th style={{ width: "15px" }}></th>
                    <th className="username">
                      {" "}
                      <FormattedMessage
                        id={"leads.properties.mappingProperties"}
                        values={{
                          var:
                            props.integration[0].toUpperCase() +
                            props.integration.slice(1),
                        }}
                      />{" "}
                    </th>
                    <th>
                      <div style={{ width: "150%" }}></div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {mappedProperties.map((kasprProperty, i) => (
                    <tr style={{ top: "40px" }}>
                      <td className="properties-column">
                        <div
                          className="form-group"
                          style={{ position: "relative", right: "10px" }}
                        >
                          <a
                            className="search-icon"
                            onClick={(e) => enableSearch(e, i)}
                            onBlur={handleOnBlur}
                          >
                            <img src="/assets/images/search-icon.svg" alt="" />
                          </a>
                          {isCustomValue[i] ? (
                            <OverlayTrigger
                              placement="top"
                              overlay={(propsOverlay) =>
                                Tooltip({
                                  ...propsOverlay,
                                  data: props.intl.formatMessage({
                                    id: "leads.properties.switchKasprProperty",
                                  }),
                                })
                              }
                            >
                              <input
                                type="text"
                                placeholder={
                                  isCustomValue[i]
                                    ? props.intl.formatMessage({
                                        id: "leads.properties.writeProperty",
                                      })
                                    : "..."
                                }
                                value={kasprProperty.replace(
                                  "customField-",
                                  ""
                                )}
                                onChange={(e) => onChangeKaspr(e, i)}
                                onBlur={handleOnBlur}
                                autoComplete={"off"}
                              />
                            </OverlayTrigger>
                          ) : (
                            <input
                              type="text"
                              placeholder={
                                isCustomValue[i]
                                  ? props.intl.formatMessage({
                                      id: "leads.properties.writeProperty",
                                    })
                                  : "..."
                              }
                              value={
                                kasprProperty.indexOf("customField-") === -1 &&
                                Object.keys(kasprProperties).indexOf(
                                  kasprProperty
                                ) === -1
                                  ? kasprProperty
                                  : props.intl.formatMessage({
                                      id: "leads.properties." + kasprProperty,
                                    })
                              }
                              onFocus={() => {
                                setPropertiesAutoComplete(
                                  Object.keys(kasprProperties)
                                );
                                setPropertyIndex(i);
                                setShowKasprPropertiesAutoComplete(true);
                                setShowAutoComplete(true);
                              }}
                              onChange={(e) => onChangeKaspr(e, i)}
                              onBlur={handleOnBlur}
                              autoComplete={"off"}
                            />
                          )}
                          {showAutoComplete &&
                            showKasprPropertiesAutoComplete &&
                            i === propertyIndex &&
                            !isCustomValue[i] && (
                              <div
                                className="form-group"
                                style={{
                                  "max-height": "225px",
                                  overflowY: "scroll",
                                  borderRadius: "5px",
                                  boxShadow: "0px 5px 6px rgba(0, 0, 0, 0.2)",
                                  background: "white",
                                  width: "100%",
                                  position: "absolute",
                                  zIndex: 10,
                                }}
                              >
                                <form>
                                  <div
                                    className={"two-div"}
                                    style={{ display: "flex" }}
                                  >
                                    <ListDrop
                                      type={"kaspr"}
                                      title={""}
                                      defaultLabel={""}
                                      properties={propertiesAutoComplete}
                                      onSelectItem={onSelectItem("kaspr", i)}
                                      disableSearch={disableSearch(i)}
                                      style={{ border: "2px solid red" }}
                                      value={mappedProperties[i] || null}
                                      dropDownStyle={{
                                        width: "139%",
                                        marginTop: 5,
                                      }}
                                      formInStyle={{ width: "60%" }}
                                    />
                                  </div>
                                </form>
                              </div>
                            )}
                        </div>
                      </td>
                      <td>
                        <div style={{ width: "80%" }}>
                          <span className="ic-config">
                            <img src="/assets/images/ic-config.svg" alt="" />
                          </span>
                        </div>
                      </td>
                      <td className="properties-column">
                        <div
                          className="form-group"
                          style={{ position: "relative", left: "10px" }}
                        >
                          <span className="search-icon">
                            <img src="/assets/images/search-icon.svg" alt="" />
                          </span>
                          <input
                            type="text"
                            placeholder={"..."}
                            value={mappedValues[i]}
                            onFocus={() => {
                              setPropertyIndex(i);
                              setShowKasprPropertiesAutoComplete(false);
                              setShowAutoComplete(true);
                              setPropertiesAutoComplete(integrationProperties);
                            }}
                            onChange={(e) => onChangeIntegration(e, i)}
                            onBlur={handleOnBlur}
                            autoComplete={"off"}
                          />
                          {showAutoComplete &&
                            !showKasprPropertiesAutoComplete &&
                            i === propertyIndex && (
                              <div
                                className="form-group"
                                style={{
                                  "max-height": "225px",
                                  overflowY: "auto",
                                  borderRadius: "5px",
                                  boxShadow: "0px 5px 6px rgba(0, 0, 0, 0.2)",
                                  background: "white",
                                  width: "100%",
                                  position: "absolute",
                                  zIndex: 10,
                                }}
                              >
                                <form className="" onSubmit={(e) => {}}>
                                  <div
                                    className={"two-div"}
                                    style={{ display: "flex" }}
                                  >
                                    <ListDrop
                                      type={props.integration}
                                      title={""}
                                      defaultLabel={"choose property"}
                                      properties={propertiesAutoComplete}
                                      onSelectItem={onSelectItem(
                                        "integration",
                                        i
                                      )}
                                      style={{ border: "2px solid red" }}
                                      value={mappedProperties[i] || null}
                                      dropDownStyle={{
                                        width: "138%",
                                        marginTop: 5,
                                      }}
                                      formInStyle={{
                                        width: "60%",
                                      }}
                                    />
                                  </div>
                                </form>
                              </div>
                            )}
                        </div>
                      </td>
                      <td style={{ left: "30px" }}>
                        <div className="button-ui delete-account">
                          <div
                            style={{
                              height: "30px",
                              padding: "0px 10px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src="/assets/images/ic_delete_g.png"
                              alt=""
                              style={{ padding: "35%" }}
                              onClick={(e) => handleDeleteMapping(e, i)}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <div
                      style={{
                        color: "#3b53d1",
                        fontSize: "18px",
                        fontWeight: 500,
                        letterSpacing: "0.16px",
                        lineHeight: "20px",
                        paddingTop: "10px",
                      }}
                    >
                      <div
                        className="right-ui"
                        style={{
                          height: "30px",
                          marginLeft: "20px",
                          padding: "0px 10px",
                          alignItems: "center",
                          display: "inline-block",
                        }}
                        onClick={addMapping}
                      >
                        <div
                          className="quantity-btn-ui"
                          style={{ display: "inline", cursor: "pointer" }}
                        >
                          <button
                            type="button"
                            id="add2"
                            className="quty-btn add"
                          >
                            <span className="icon-ic_add">
                              <img src="/assets/images/ic-add.svg" alt="" />
                            </span>
                          </button>
                        </div>
                        <FormattedMessage id={"leads.properties.addMapping"} />
                      </div>
                    </div>
                  </tr>
                </tbody>
                {/*<MappingProperties*/}
                {/*  integration={props.integration}*/}
                {/*  mappedProperties={mappedProperties}*/}
                {/*  setMappedProperties={setMappedProperties}*/}
                {/*  mappedValues={mappedValues}*/}
                {/*  setMappedValues={setMappedValues}*/}
                {/*  isCustomValue={isCustomValue}*/}
                {/*  setIsCustomValue={setIsCustomValue}*/}
                {/*  integrationProperties={{*/}
                {/*    integrationProperties,*/}
                {/*    kasprProperties,*/}
                {/*  }}*/}
                {/*  setError={setError}*/}
                {/*/>*/}
              </table>
            )}
            {error && (
              <div
                className="text-center  error  kaspr-form-text-error"
                style={{ top: 10, width: "90%" }}
              >
                {error + " "}
              </div>
            )}
          </div>
          {props.isLoading && (
            <div
              className="configration-inner-ui"
              style={{ textAlign: "center" }}
            >
              <img
                src={"/assets/images/loading.gif"}
                alt={"loading"}
                style={{
                  height: "80px",
                  marginTop: "80px",
                  marginBottom: "80px",
                }}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="modal-footer border-0">
          <a href="#" className="btn1 btn-md" onClick={handleSubmitMapping}>
            <FormattedMessage id={"leads.validateProperties"} />
          </a>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

export default injectIntl(MappingModal);
